import React, { useState } from "react";
import { TimeField } from "@opendate-app/setlist";

import { useCustomCampaignShowContext } from "../CustomCampaignShowContainer";
import { MINUTE_OPTIONS } from "../minutesToLabel";

const MINUTE_STEP = 15;
const LAST_MINUTE = MINUTE_OPTIONS[MINUTE_OPTIONS.length - 1];

const formInputContainerStyle = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: 8,
  alignItems: "center",
  margin: "24px 48px 24px 0px",
};

const labelStyle = {
  margin: 0,
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "24px",
  color: "var(--sl-text-primary)",
};

const hintStyle = {
  fontSize: 14,
  lineHeight: "20px",
  color: "var(--sl-text-tertiary)",
  marginTop: -8,
  maxWidth: 340,
};

const visuallyHiddenStyle = {
  position: "absolute",
  width: 1,
  height: 1,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
};

const toStep = (minute) => Math.min(LAST_MINUTE, Math.round(minute / MINUTE_STEP) * MINUTE_STEP);

export default () => {
  const {
    selectedNodeFormState,
    setSelectedNodeFormState,
    customCampaign,
  } = useCustomCampaignShowContext();

  const [resyncKeys, setResyncKeys] = useState({ start_minute: 0, end_minute: 0 });

  const updateMinute = (key) => (minute) => {
    if (minute === null) return;
    const steppedMinute = toStep(minute);
    if (steppedMinute !== minute && steppedMinute === selectedNodeFormState?.node_data?.[key]) setResyncKeys((previous) => ({ ...previous, [key]: previous[key] + 1 }));
    setSelectedNodeFormState({
      ...selectedNodeFormState,
      node_data: {
        ...selectedNodeFormState.node_data,
        [key]: steppedMinute,
      },
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div style={formInputContainerStyle}>
        <label htmlFor="send-window-start-time" style={labelStyle}>Send between<span style={visuallyHiddenStyle}> start time</span></label>
        <div style={{ width: 128 }}>
          <TimeField
            key={`start-${resyncKeys.start_minute}`}
            id="send-window-start-time"
            minuteStep={MINUTE_STEP}
            max={LAST_MINUTE}
            value={selectedNodeFormState?.node_data?.start_minute ?? null}
            onChange={updateMinute("start_minute")}
          />
        </div>
        <label htmlFor="send-window-end-time" style={labelStyle}>and<span style={visuallyHiddenStyle}> end time</span></label>
        <div style={{ width: 128 }}>
          <TimeField
            key={`end-${resyncKeys.end_minute}`}
            id="send-window-end-time"
            minuteStep={MINUTE_STEP}
            max={LAST_MINUTE}
            value={selectedNodeFormState?.node_data?.end_minute ?? null}
            onChange={updateMinute("end_minute")}
          />
        </div>
      </div>
      <div style={hintStyle}>
        Times are in {customCampaign?.time_zone || "the campaign's"} time.
        <br />
        Messages that arrive outside this window wait until it next opens.
      </div>
    </div>
  );
};
